var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent42(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#48473c",
    opacity: 1,
    d: "M313.886+273.243L310.781+359.516C309.813+383.337+328.678+403.06+352.918+403.568L681.543+400.57C705.783+401.078+725.331+382.163+725.205+358.323L724.74+270.557"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#776f92",
    d: "M876.999+915.886L183.402+915.886C165.861+915.886+152.367+901.685+153.262+884.167L167.853+598.697C167.853+527.055+232.424+483.214+281.359+478.515L413.788+469.661L622.622+469.234L747.281+478.515C808.61+483.214+860.787+527.055+860.787+598.697L876.999+915.886Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3d5b9",
    opacity: 1,
    d: "M511.722+110.569L519.278+110.569C617.868+110.569+697.791+196.81+697.791+303.194L697.791+303.194C697.791+409.578+617.868+495.819+519.278+495.819L511.722+495.819C413.131+495.819+333.208+409.578+333.208+303.194L333.208+303.194C333.208+196.81+413.131+110.569+511.722+110.569Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M513.641+350.256L518.054+350.256C575.632+350.256+622.309+400.324+622.309+462.085L622.309+462.085C622.309+523.847+575.632+573.914+518.054+573.914L513.641+573.914C456.062+573.914+409.386+523.847+409.386+462.085L409.386+462.085C409.386+400.324+456.062+350.256+513.641+350.256Z",
    fill: "#f3d5b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.305+86.6999C608.977+81.519+710.289+161.931+728.204+278.227C728.268+292.866+720.906+293.214+702.702+291.41C669.807+288.152+634.895+284.512+588.816+279.406C577.681+278.172+558.536+185.591+558.536+185.591C558.536+185.591+563.196+277.635+548.662+278.13C537.578+278.507+467.352+277.823+455.845+278.768C447.205+279.477+455.845+182.4+455.845+182.4C455.845+182.4+429.924+279.329+422.273+280.044C389.146+283.142+306.296+292.648+309.05+275.577C327.482+161.34+411.611+92.2068+513.305+86.6999Z",
    opacity: 1,
    fill: "#48473c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent42);
export default __webpack_public_path__ + "static/media/Student 42.49cd267d5482b93f82ec9449eaf68e90.svg";
export { ForwardRef as ReactComponent };